import { Host, h } from '@stencil/core';
export class AibaProduct {
  constructor() {
    this.triggerInfoBlock = (event, details) => {
      event.data = details;
      this.infoButtonClicked.emit(event);
    };
    this.detail = undefined;
    this.isBinEnabled = undefined;
    this.isMikMakEnabled = undefined;
    this.styles = undefined;
    this.classes = undefined;
    this.data = undefined;
    this.handlers = undefined;
  }
  componentDidLoad() {
    if (this.handlers && this.handlers.productDidLoad) {
      this.handlers.productDidLoad();
    }
  }
  async handleClickHandler(event, element) {
    var _a;
    if (!element || !(element === null || element === void 0 ? void 0 : element.data) || !((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.handleClick)) {
      return;
    }
    const handlerName = element.data.handleClick;
    this.handlers && this.handlers[handlerName] && (await this.handlers[handlerName](event, element));
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (typeof this.detail === 'string' || typeof this.data === 'string') {
      if (this.detail)
        this.detail = JSON.parse(this.detail);
      if (this.data)
        this.data = JSON.parse(this.data);
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: "product-wrapper__product" }, this.data &&
      ((_d = (_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.elements) === null || _d === void 0 ? void 0 : _d.map((component) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
        {
          if (component && component['name'] === 'aiba-tag') {
            return h("aiba-label", Object.assign({ text: ((_a = component === null || component === void 0 ? void 0 : component.data) === null || _a === void 0 ? void 0 : _a.dynamic) ? (_b = this.detail) === null || _b === void 0 ? void 0 : _b.routineName : component['data']['text'] }, component['data']));
          }
          if (component && component['name'] === 'aiba-button')
            return (h("aiba-button", Object.assign({}, component['data'], { handleClick: (event) => this.handlers && this.handlers.handleShareButtonClick(event, this.detail) })));
          if (component && component['name'] === 'aiba-info')
            return (h("aiba-button", Object.assign({}, component['data'], { handleClick: (event) => this.triggerInfoBlock(event, this.detail) })));
          if (component && component['name'] === 'aiba-img')
            return (h("div", { class: "product-wrapper__product__img" }, h("img", Object.assign({ src: (_c = this.detail) === null || _c === void 0 ? void 0 : _c.imageUrl, alt: ((_d = this.detail) === null || _d === void 0 ? void 0 : _d.imageAltText) ? (_e = this.detail) === null || _e === void 0 ? void 0 : _e.imageAltText : (_f = component['data']) === null || _f === void 0 ? void 0 : _f.altText }, component['data']))));
          if (component && component['name'] === 'aiba-link-img')
            return (h("div", { class: "product-wrapper__product__img" }, h("aiba-link", Object.assign({}, component['data'], { href: (_g = this.detail) === null || _g === void 0 ? void 0 : _g.pageUrl }), h("img", { src: (_h = this.detail) === null || _h === void 0 ? void 0 : _h.imageUrl, alt: ((_j = this.detail) === null || _j === void 0 ? void 0 : _j.imageAltText) ? (_k = this.detail) === null || _k === void 0 ? void 0 : _k.imageAltText : (_l = component['data']) === null || _l === void 0 ? void 0 : _l.altText }))));
          if (component && component['name'] === 'aiba-product-ratings')
            return (h("aiba-product-ratings", { sku: ((_m = this.detail) === null || _m === void 0 ? void 0 : _m.identifierValue) ? (_o = this.detail) === null || _o === void 0 ? void 0 : _o.identifierValue : '', handlers: this.handlers, upc: ((_p = this.detail) === null || _p === void 0 ? void 0 : _p.smartProductId) ? (_q = this.detail) === null || _q === void 0 ? void 0 : _q.smartProductId : '', data: component['data'], template: ((_r = this.detail) === null || _r === void 0 ? void 0 : _r.template) ? (_s = this.detail) === null || _s === void 0 ? void 0 : _s.template : '', productName: ((_t = this.detail) === null || _t === void 0 ? void 0 : _t.productName) ? (_u = this.detail) === null || _u === void 0 ? void 0 : _u.productName : '' }));
          if (component && component['name'] === 'aiba-link-title')
            return h("aiba-link", Object.assign({}, component['data'], { href: (_v = this.detail) === null || _v === void 0 ? void 0 : _v.pageUrl, text: (_w = this.detail) === null || _w === void 0 ? void 0 : _w.productName, class: "product-wrapper__product__title-link" }));
          if (component && component['name'] === 'aiba-label' && component['data'] && component.data['tag'] === 'divCustom') {
            return (h("div", { class: "product-wrapper__product-info" }, (_y = (_x = component.data) === null || _x === void 0 ? void 0 : _x.elements) === null || _y === void 0 ? void 0 : _y.map((innerComponent) => {
              var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
              if (innerComponent && innerComponent['name'] === 'aiba-category-name')
                return h("aiba-label", Object.assign({ text: (_a = this.detail) === null || _a === void 0 ? void 0 : _a.category }, innerComponent['data']));
              if (innerComponent && innerComponent['name'] === 'aiba-label')
                return h("aiba-label", Object.assign({ text: (_b = this.detail) === null || _b === void 0 ? void 0 : _b.productName }, innerComponent['data']));
              if (innerComponent && innerComponent['name'] === 'aiba-short-description-label') {
                return h("aiba-label", Object.assign({ text: (_c = this.detail) === null || _c === void 0 ? void 0 : _c.shortDescription }, innerComponent['data']));
              }
              if (innerComponent && innerComponent['name'] === 'aiba-description-label' && innerComponent['tag'] === "additional") {
                return h("aiba-label", Object.assign({ text: (_d = this.detail) === null || _d === void 0 ? void 0 : _d.additionalDescription }, innerComponent['data']));
              }
              if (innerComponent && innerComponent['name'] === 'aiba-variants-button') {
                return (h("div", { class: "variants-button" }, ((_e = this.detail) === null || _e === void 0 ? void 0 : _e.variants) &&
                  ((_g = (_f = this.detail) === null || _f === void 0 ? void 0 : _f.variants) === null || _g === void 0 ? void 0 : _g.map((prod_variants, index) => {
                    return (h("aiba-button", Object.assign({}, innerComponent['data'], { value: prod_variants === null || prod_variants === void 0 ? void 0 : prod_variants.title, varientId: prod_variants.id, disabled: !!(prod_variants === null || prod_variants === void 0 ? void 0 : prod_variants.disabled), classes: index === 0 ? 'active' : '', handleClick: async (event) => {
                        this.handlers && this.handlers.handleVarientsClick && this.handlers.handleVarientsClick(event, prod_variants);
                      } })));
                  }))));
              }
              if (innerComponent && innerComponent['name'] === 'aiba-variants-price') {
                return (h("div", { class: "variant-price" }, h("aiba-label", Object.assign({}, innerComponent['data'], { innerHTML: (_j = (_h = this.detail) === null || _h === void 0 ? void 0 : _h.variants[0]) === null || _j === void 0 ? void 0 : _j.priceToDisplay }))));
              }
              if (innerComponent && innerComponent['name'] === 'aiba-quantity-selector') {
                return h("aiba-quantity-selector", { data: Object.assign({}, innerComponent['data']), max: (_k = this.detail) === null || _k === void 0 ? void 0 : _k.maxQuantity, handlers: this.handlers });
              }
              if (innerComponent && innerComponent['name'] === 'aiba-bin-view' && this.isBinEnabled && ((_l = this.detail) === null || _l === void 0 ? void 0 : _l.smartProductId))
                return h("aiba-bin-view", Object.assign({ smartId: (_m = this.detail) === null || _m === void 0 ? void 0 : _m.smartProductId }, component['data'], { product: this.detail, handlers: this.handlers }));
            })));
          }
          if (component && component['name'] === 'aiba-quantity-selector')
            return h("aiba-quantity-selector", { data: Object.assign({}, component['data']), handlers: this.handlers });
          if (component && component['name'] === 'aiba-bin-view' && !this.isMikMakEnabled && this.isBinEnabled && ((_z = this.detail) === null || _z === void 0 ? void 0 : _z.smartProductId))
            return h("aiba-bin-view", Object.assign({ smartId: (_0 = this.detail) === null || _0 === void 0 ? void 0 : _0.smartProductId }, component['data'], { product: this.detail, handlers: this.handlers }));
          if (component && component['name'] === 'aiba-mik-mak' && this.isMikMakEnabled && ((_1 = this.detail) === null || _1 === void 0 ? void 0 : _1.smartProductId))
            return (h("aiba-mik-mak", Object.assign({ product: this.detail, appid: component['data'].appId, smartProductId: (_2 = this.detail) === null || _2 === void 0 ? void 0 : _2.smartProductId }, component['data'], { label: component['data'].label, handlers: this.handlers })));
          if (component && component['name'] === 'aiba-link' && !this.isMikMakEnabled && !this.isBinEnabled)
            return (h("div", { class: "product-wrapper__product__link" }, h("aiba-link", Object.assign({ href: (_3 = this.detail) === null || _3 === void 0 ? void 0 : _3.pageUrl, clickEvent: (event) => this.handlers && this.handlers.handleLearnMoreClick(this.detail, event), "data-product": this.detail ? JSON.stringify(this.detail) : '', title: `${(_4 = component === null || component === void 0 ? void 0 : component.data) === null || _4 === void 0 ? void 0 : _4.title} ${(_5 = this.detail) === null || _5 === void 0 ? void 0 : _5.productName}` }, component['data']), component &&
              component['data']['elements'].map((comp) => {
                if (comp && comp['name'] === 'aiba-label')
                  return h("aiba-label", Object.assign({}, comp['data']));
                if (comp && comp['name'] === 'img')
                  return h("img", Object.assign({}, comp['data'], { class: "external_link" }));
              }))));
        }
      }))), this.data &&
      ((_h = (_g = (_f = (_e = this.data) === null || _e === void 0 ? void 0 : _e.product) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.elements) === null || _h === void 0 ? void 0 : _h.map((component) => {
        var _a, _b;
        if (component && component['name'] === 'aiba-label' && component['data'] && component.data['tag'] === 'div') {
          return (h("div", { class: "product-wrapper__product-info" }, (_b = (_a = component.data) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b.map((innerComponent) => {
            var _a, _b, _c, _d, _e, _f;
            if (innerComponent && innerComponent['name'] === 'aiba-label')
              return h("aiba-label", Object.assign({ text: (_a = this.detail) === null || _a === void 0 ? void 0 : _a.productName }, innerComponent['data']));
            if (innerComponent && innerComponent['name'] === 'aiba-short-description-label') {
              return h("aiba-label", Object.assign({ text: (_b = this.detail) === null || _b === void 0 ? void 0 : _b.shortDescription }, innerComponent['data']));
            }
            if (innerComponent && innerComponent['name'] === 'aiba-quiz-response-label') {
              return (h("aiba-label", Object.assign({}, innerComponent['data'], { text: innerComponent['data']['text'] ? innerComponent['data']['text'].replace('${quiz_answer}', (_c = this.detail) === null || _c === void 0 ? void 0 : _c.quizResponse) : '' })));
            }
            if (innerComponent && innerComponent['name'] === 'aiba-description-label') {
              return h("aiba-label", Object.assign({ text: (_d = this.detail) === null || _d === void 0 ? void 0 : _d.description }, innerComponent['data']));
            }
            if (innerComponent && innerComponent['name'] === 'aiba-bin-view-product-info' && !this.isMikMakEnabled && this.isBinEnabled && ((_e = this.detail) === null || _e === void 0 ? void 0 : _e.smartProductId)) {
              return h("aiba-bin-view", Object.assign({ smartId: (_f = this.detail) === null || _f === void 0 ? void 0 : _f.smartProductId }, innerComponent['data'], { product: this.detail, handlers: this.handlers }));
            }
            if (innerComponent && innerComponent['name'] === 'aiba-button') {
              return h("aiba-button", Object.assign({}, innerComponent.data, { handleClick: event => this.handleClickHandler(event, innerComponent ? innerComponent : '') }));
            }
          })));
        }
      }))));
  }
  static get is() { return "aiba-product"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-product.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-product.css"]
    };
  }
  static get properties() {
    return {
      "detail": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any | ProductDetailsType",
          "resolved": "any",
          "references": {
            "ProductDetailsType": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "detail",
        "reflect": false
      },
      "isBinEnabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-bin-enabled",
        "reflect": false
      },
      "isMikMakEnabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mik-mak-enabled",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any | object",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get events() {
    return [{
        "method": "shareButtonClicked",
        "name": "shareButtonClicked",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }, {
        "method": "infoButtonClicked",
        "name": "infoButtonClicked",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
}
//# sourceMappingURL=aiba-product.js.map
